import {Component, OnInit, Input, OnChanges, Output, EventEmitter} from '@angular/core';
import { Synchro } from '../model/synchro';
import { ProjectService } from '../project/project.service';
import { DataNavigationState } from '../model/data-navigation-state';
import { ClickEvent } from '../project/pagination/pagination.component';
import {Device} from '../model/device';

@Component({
    selector: 'respondents-by-synchro',
    template: `<div style="padding: 10px;">
          <table>
            <thead>
            <tr>
              <th>{{'time'|translate}}</th>
              <th>{{'DeviceID'}}</th>
              <th>{{'Src IP Address'}}</th>
              <th>{{'device'|translate}}</th>
              <th>Action</th>
            </tr>
            </thead>
            <tbody>
            <tr class="elem" *ngFor="let synchro of itemsToShow">
              <td class="time">
                <div (click)="onSynchroClick(synchro)">
                  {{synchro.time}}
                  <span class="badge badge-light">{{synchro.totalNumberOfRespondents}}</span>
                </div>
              </td>
              <td class="time">
                <div>
                  {{synchro.deviceId}}
                </div>
              </td>
              <td class="time">
                <div>
                  {{synchro.ipAddress}}
                </div>
              </td>
              <td class="time">
                <div>
                  {{synchro.deviceName}}
                </div>
              </td>
              <td class="time">
                <span (click)="onDeletedSynchro(synchro)" class="deleteSynchroIcon"><i class="fas fa-times"></i></span>
              </td>
            </tr>
            </tbody>
          </table>
                    <div class="row col-md-12 containerBox" *ngIf="synchros != null && synchros.length > 0">
                      <div class="paginationComponent">

                            <pagination [indexSelectedItem]="navigationState.paginationNumber"
                                        [item-can-change]="true"
                                        [item-by-page]="synchro_by_page"
                                        [items]="synchros"
                                        (beforePageChange)="onBeforePageChange($event)"
                                        (go)="onBeforePageChange($event)">
                            </pagination>
                      </div>
                    </div>
    </div>
    `,
    styles: [
        `
            .containerBox{height:100px;}
        .elem{
          background-color: lightsteelblue;
        }
        table {width: 100%;table-layout: fixed;}
        tr:nth-child(even){background-color: #a5cafc}
        tr:nth-last-child(odd){background-color: #d4dfea}
        thead tr{background-color: #333c4e;height:50px;}

        thead tr th {color:white; text-align: left; padding-left: 90px;}
        thead tr th:first-child{color:white;border-top-left-radius: 5px;}
        thead tr th:last-child{color:white;border-top-right-radius: 5px;}

        tbody tr{height:50px;}

        .time {padding-left:90px;}

        .elem:hover{ background-color: darkkhaki;font-size: large;}

        .paginationComponent{width:50%;margin:0 auto;position: absolute;left:40%;top:10%;}

        .deleteSynchroIcon{color:red;font-size: large}

        .grid-container {
          display: grid;
          grid-template-columns: auto auto auto;
          padding: 10px;
        }
        .grid-item {
          padding: 20px;
          text-align: center;
        }
        tbody tr:last-child td:first-child {border-bottom-left-radius: 5px;}
        tbody tr:last-child td:last-child {border-bottom-right-radius: 5px;}

    `
    ]
})
export class RespondentsBySynchroComponent implements OnInit, OnChanges {
    @Input('synchros') synchros: Synchro[] = null;
    @Input('navigation-state') navigationState: DataNavigationState;
    @Input('questionnaireID') _questionnaireId:number;
    @Output() _explodeSynchroEvent:EventEmitter<Device> =  new EventEmitter();
    @Input() synchro_by_page = 5;
    private _indexItem = 1;

    private _showAreYouSureDialog = false;
    private _synchroToDelete = null;
    private itemsToShow = new Array<Synchro>();
    private pageNumber=1;
    constructor(private _projectService: ProjectService) {

    }

    init() {
        if (this.navigationState != null) {
            const synchro = this.getSynchro(this.navigationState.synchroId);
            if (synchro != null && synchro.respondents != null && synchro.respondents.length > 0) {
            } else {
                // this.showFirstSynchro();
            }

        } else {
            // this.showFirstSynchro();
        }
        this.navigateToPage(1);
    }

    ngOnInit() {
       this.init();
    }

    ngOnChanges() {
       this.init();
    }

    changePage($event:ClickEvent, showLastRespondent:boolean = false) {
        const start = ($event.index -1) * this.synchro_by_page;

        let end = start + this.synchro_by_page - 1;

        if (end >= this.synchros.length) {
            end = this.synchros.length - 1;
        }

        if (this.synchros.length > 0) {

        }

        this._indexItem = $event.index;
    }

    onSynchroClick(synchro) {


        this._explodeSynchroEvent.emit(synchro);

        // we do not explode a synchro in this component anymore
       /* if (synchro){
            synchro.expanded = !synchro.expanded;
        }*/
    }

    onDeletedSynchro(synchro) {
        this._synchroToDelete = synchro;
        this._showAreYouSureDialog = true;
    }

    deleteSynchro(synchro) {
        const index = this.synchros.indexOf(synchro);

        this._projectService.deleteSynchro(synchro.id)
            .then(response => {
                this.synchros.splice(index, 1);

                // Changer l'index si on vient de supprimer la derniere synchro visible TODO
                const start = (this._indexItem -1) * this.synchro_by_page;
                if (start === this.synchros.length && this._indexItem > 1) {
                    this._indexItem --;
                }

                this._showAreYouSureDialog = false;
            },
            error => {
                console.log('Could not delete the Respondent.');
                this._showAreYouSureDialog = false;
            });
        this._synchroToDelete = null;
    }

    onRespondentDeleted(respondent) {
        const sync = this.getSynchro(respondent.synchroId);

        if (sync != null) {

            if (sync.respondents.length === 1) {
                this.deleteSynchro(sync);
            } else {
                let index = sync.respondents.indexOf(respondent);
                sync.respondents.splice(index, 1);

                if (index === sync.respondents.length) {
                    index --;
                }

                /*this._activeRespondent = sync.respondents[index];
                this._questionnaireUnchanged = QuestionnaireUtil.clone(this._activeRespondent.questionnaireProject); */
            }
        }
    }
    onBeforePageChange($event:ClickEvent) {
      if ( $event.index > 0  ) {
        this.pageNumber = $event.index;
        this.setPaginationNumber();
        const startIndex = this.pageNumber -1;
        this.getSynchros(startIndex*this.synchro_by_page,(startIndex*this.synchro_by_page)+this.synchro_by_page);
      }
    }

  setPaginationNumber() {
    this.navigationState.paginationNumber = this.pageNumber;
  }

    navigateToPage(pageNumber:number) {
      let startIndex:number = pageNumber;
      if(pageNumber!==0) {
        startIndex =  pageNumber-1;
      }
      this.getSynchros(startIndex*this.synchro_by_page,(startIndex*this.synchro_by_page)+this.synchro_by_page);
    }

     getSynchro(deviceID): Synchro {
        let sync: Synchro = null;
        for (const synchro of this.synchros) {
            if (synchro.deviceId === deviceID) {
                sync = synchro;
                break;
            }
        }
        return sync;
    }

  private getSynchros(start: number, end: number) {
    this.itemsToShow.length = 0;
    for(let i = start;i<end;i++) {
      if(i < this.synchros.length) {
        this.itemsToShow.push(this.synchros[i]);
      } else {break;}
    }
  }
}
